/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Passwordstrengthpwnedwarning3Inputs */

const en_passwordstrengthpwnedwarning3 = /** @type {(inputs: Passwordstrengthpwnedwarning3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This password was found in ${i?.count} data breaches. Do not use it.`)
};

const de_passwordstrengthpwnedwarning3 = /** @type {(inputs: Passwordstrengthpwnedwarning3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Passwort wurde in ${i?.count} Datenlecks gefunden. Nimm ein anderes.`)
};

/**
* | output |
* | --- |
* | "This password was found in {count} data breaches. Do not use it." |
*
* @param {Passwordstrengthpwnedwarning3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordstrengthpwnedwarning3 = /** @type {((inputs: Passwordstrengthpwnedwarning3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordstrengthpwnedwarning3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordstrengthpwnedwarning3(inputs)
	return de_passwordstrengthpwnedwarning3(inputs)
});
export { passwordstrengthpwnedwarning3 as "passwordStrengthPwnedWarning" }